import React, { useEffect } from "react";
import Eerstejaar from "../components/Eerstejaar";
import Tweedejaar from "../components/Tweedejaar";
import gsap from "gsap";

export default function Programma() {
    useEffect(() => {
        gsap.fromTo(
            ".main-container",
            { opacity: 0 },
            { opacity: 1, duration: 1 }
        );
    }, []);

    return (
        <div className="main-container">
            <div className="posts-header">
                <div className="post-content">
                    <h1>
                        Hoe ziet onze
                        <br />
                        Programma eruit?
                    </h1>
                    <div className="purple-line"></div>
                    <p>
                        Deze gevarieerde dagopleiding duurt twee jaar, bestaat
                        uit 120 studiepunten en bevat 1200 uur praktijk. We
                        streven naar klasgroepen van ongeveer 30 studenten. Zo
                        kunnen we maximaal inzetten op persoonlijke
                        ondersteuning.
                    </p>
                </div>
                <ul class="opleidingen">
                    <li class="opleiding-item">
                        <a href="#sectionOne">Eerste jaar</a>
                    </li>
                    <li class="opleiding-item">
                        <a href="#sectionTwo">Tweede jaar</a>
                    </li>
                </ul>
            </div>
            <div className="first-year">
                <Eerstejaar />
                <Tweedejaar />
            </div>
        </div>
    );
}
